import styled, { css } from 'styled-components';
import { flexbox, space, layout, fontSize } from 'styled-system';
import { transparentize } from 'polished';

import { BadgeProps } from 'ui/types/component';

const Badge = styled.span<BadgeProps>`
  padding: ${({ theme }) => theme.space[1]} ${({ theme }) => theme.space[2]};
  font-size: 0.75rem;
  text-align: center;
  line-height: 1;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  border-radius: 100px;
  white-space: nowrap;
  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme, variant }) =>
    variant === 'primary'
      ? theme.colors.primary
      : variant === 'info'
      ? theme.colors.border.info
      : variant === 'success'
      ? theme.colors.border.success
      : variant === 'error'
      ? theme.colors.border.error
      : variant === 'warning'
      ? theme.colors.border.warning
      : theme.colors.border.default};
  color: ${({ theme, variant }) =>
    variant === 'primary'
      ? theme.colors.primary
      : variant === 'info'
      ? theme.baseColors.blue[9]
      : variant === 'success'
      ? theme.baseColors.green[9]
      : variant === 'error'
      ? theme.baseColors.red[9]
      : variant === 'warning'
      ? theme.baseColors.yellow[8]
      : theme.colors.text.body};
  background-color: ${({ theme, variant }) =>
    variant === 'primary'
      ? transparentize(0.6, theme.colors.primary)
      : variant === 'info'
      ? transparentize(0.2, theme.baseColors.blue[1])
      : variant === 'success'
      ? transparentize(0.2, theme.baseColors.green[2])
      : variant === 'error'
      ? transparentize(0.2, theme.baseColors.red[2])
      : variant === 'warning'
      ? theme.baseColors.yellow[3]
      : 'var(--color-neutral-contrast-03)'};

  html[data-color-mode='dark'] && {
    background-color: ${({ theme, variant }) =>
      variant === 'primary'
        ? transparentize(0.6, theme.colors.primary)
        : variant === 'info'
        ? theme.baseColors.blue[1]
        : variant === 'success'
        ? transparentize(0.2, theme.baseColors.green[2])
        : variant === 'error'
        ? transparentize(0.2, theme.baseColors.red[2])
        : variant === 'warning'
        ? theme.baseColors.yellow[3]
        : 'var(--color-neutral-contrast-03)'};
  }
  ${flexbox}
  ${space}
	${layout}
	${fontSize}
`;
export { Badge };
